import { render, staticRenderFns } from "./SummaryItems.vue?vue&type=template&id=cd7f09f8&scoped=true"
import script from "./SummaryItems.vue?vue&type=script&lang=ts"
export * from "./SummaryItems.vue?vue&type=script&lang=ts"
import style0 from "./SummaryItems.vue?vue&type=style&index=0&id=cd7f09f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7f09f8",
  null
  
)

export default component.exports